export default "__VITE_ASSET__3Uu3jQr6__"